import { Injectable } from "@angular/core";
import { APIHelper } from "src/shared/services/api-helper/api-helper.service";
import { API_URLS } from "src/environments/env-routes";
import {
  Outcome,
  Task,
  TaskStatus
} from "../../viewer/shared/models/task.model";

@Injectable({
  providedIn: "root"
})
export class TasksService {
  constructor(private api: APIHelper) {}

  getTasks(args?: string) {
    return this.api.requestApi({
      action: API_URLS.getTasks.tasks,
      method: "GET",
      queryArgs: args
    });
  }
  getAllTasks(actualPage = 0, nbElements = 100) {
    const args = `skipCount=${actualPage *
      nbElements}&maxItems=${nbElements}`;
      return this.getTasks(args);
  }
  getCurrentTasks(actualPage = 0, nbElements = 100) {
    const args = `where=(includeTaskVariables=true AND includeProcessVariables=true)&skipCount=${actualPage *
      nbElements}&maxItems=${nbElements}&orderBy=startedAt DESC`;
    return this.getTasks(args);
  }

  getCompetedTasks(actualPage = 0, nbElements = 100) {
    const args = `where=(status=completed AND includeTaskVariables=true)&skipCount=${actualPage *
      nbElements}&maxItems=${nbElements}&orderBy=startedAt DESC`;
    return this.getTasks(args);
  }

  updateTask(task: Task, args?: string) {
    if (!args) {
      args = "select=variables";
    }
    return this.api.requestApi({
      action: API_URLS.getTasks.task.replace(":taskId", task.id),
      method: "PUT",
      datas: task,
      queryArgs: args
    });
  }

  completeTask(task: Task) {
    task.state = TaskStatus.COMPLETED;
    return this.updateTask(task, "select=state,variables");
  }

  completePulseTask(taskId: string, outcome: Outcome, comment?: string) {
    const task = new Task({
      id: taskId,
      variables: [
        {
          name: "wf_reviewOutcome",
          type: "d:text",
          value: outcome,
          scope: "local"
        },
        {
          name: "bpm_comment",
          type: "d:text",
          value: comment,
          scope: "local"
        }
      ]
    });
    return this.completeTask(task);
  }

  validateDocument(taskId: string) {
    return this.completePulseTask(taskId, Outcome.APPROVE);
  }

  rejectDocument(taskId: string, comment: string) {
    return this.completePulseTask(taskId, Outcome.REJECT, comment);
  }

  getTask(taskId: string) {
    return this.api.requestApi({
      action: API_URLS.getTasks.task.replace(":taskId", taskId),
      method: "GET"
    });
  }

  getTaskVariables(taskId: string) {
    return this.api.requestApi({
      action: API_URLS.getTasks.taskVariables.replace(":taskId", taskId),
      method: "GET"
    });
  }
}
